import { safetyPageInitialState } from "./uiLandingPageSafetyPageState";

export const makeSafetyPageActions = (set, get) => ({
  setActivePage: (page) =>
    set((s) => ({ safetyPage: { ...s.safetyPage, activePage: page } })),

  // Near Miss Actions
  setSelectedNearMiss: (nearMiss) =>
    set((s) => ({
      safetyPage: { ...s.safetyPage, selectedNearMiss: nearMiss },
    })),
  setShowNearMissForm: (show) =>
    set((s) => ({ safetyPage: { ...s.safetyPage, showNearMissForm: show } })),

  // Safety Audit Checklist Actions
  setSelectedSafetyAuditChecklist: (safetyAuditChecklist) =>
    set((s) => ({
      safetyPage: {
        ...s.safetyPage,
        selectedSafetyAuditChecklist: safetyAuditChecklist,
      },
    })),
  setShowSafetyAuditChecklistForm: (show) =>
    set((s) => ({
      safetyPage: { ...s.safetyPage, showSafetyAuditChecklistForm: show },
    })),

  // Incident Investigation Actions
  setSelectedIncidentInvestigation: (incidentInvestigation) =>
    set((s) => ({
      safetyPage: {
        ...s.safetyPage,
        selectedIncidentInvestigation: incidentInvestigation,
      },
    })),
  setShowIncidentInvestigationForm: (show) =>
    set((s) => ({
      safetyPage: { ...s.safetyPage, showIncidentInvestigationForm: show },
    })),

  // Reset Actions
  resetSafetyPage: () => set({ safetyPage: safetyPageInitialState }),
});
